const filtersItems = (state = {}, action) => {
  switch (action.type) {
  case 'SET_FILTER_ITEMS_DATA':
    return action.payload;
  case 'ADD_FILTER_ITEMS_DATA':
    return { ...state, pages: action.payload };
  default:
    return state;
  }
};

export default filtersItems;
